import { createContext as t } from "react";
const e = t({});
export {
  e as default
};
